import { render, staticRenderFns } from "./InvoiceByMail.vue?vue&type=template&id=76b90521&scoped=true"
import script from "./InvoiceByMail.vue?vue&type=script&lang=js"
export * from "./InvoiceByMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b90521",
  null
  
)

export default component.exports